import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
export default {
    srParentList: config.web_mw + "Profile/GetServiceDetails",
    getRmDetails: config.web_mw + "Profile/GetServicingDetails",
    getPreFilledFormPDF: config.web_mw + "Profile/GetPreFilledFormPDF",
    getEsignUrlV2: config.web_mw + "Profile/EsignPiChainUrl",
    getEsignUrlJMW: config.jmw + config.jmw_login + "sr/esign/url",
};
